export enum InfoPageType {
	imprint = 'imprint',
	legal = 'legal-information',
	protection = 'data-protection',
}
